/* Gilt: sticky header that turns solid on scroll + mobile menu */
(function () {
  function initNav(nav) {
    if (!nav || nav.dataset.giltReady) return;
    nav.dataset.giltReady = 'true';

    var overlay = nav.dataset.overlay === 'true';
    var toggle = nav.querySelector('[data-gilt-menu-toggle]');
    var menu = nav.querySelector('.gilt-mobile-menu');
    var ticking = false;

    function update() {
      ticking = false;
      if (!overlay) return;
      nav.classList.toggle('is-solid', window.scrollY > 24);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });

    function setMenu(open) {
      if (!toggle || !menu) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.hidden = !open;
      nav.classList.toggle('menu-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        setMenu(toggle.getAttribute('aria-expanded') !== 'true');
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle && toggle.getAttribute('aria-expanded') === 'true') {
        setMenu(false);
        toggle.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) setMenu(false);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-gilt-nav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-init when the header section is reloaded
  document.addEventListener('shopify:section:load', initAll);
})();
